import { render, staticRenderFns } from "./RouterLinkLocaled.vue?vue&type=template&id=da409b66"
import script from "./RouterLinkLocaled.vue?vue&type=script&lang=js"
export * from "./RouterLinkLocaled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports